import { render, staticRenderFns } from "./Film.vue?vue&type=template&id=22f0e00d"
import script from "./Film.vue?vue&type=script&lang=ts"
export * from "./Film.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports